import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">91吃瓜</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的吃瓜视频内容平台，为您提供最新、最全的高清视频在线观看服务。
            </p>
          </div>
          <div>
            <h4 className="font-medium text-background-50 mb-3 text-sm">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-200 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-medium text-background-50 mb-3 text-sm">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-200 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-medium text-background-50 mb-3 text-sm">联系方式</h4>
            <ul className="space-y-2 text-sm text-background-400">
              <li>邮箱：contact@91chigua.com</li>
              <li>电话：400-888-9191</li>
              <li>地址：北京市朝阳区建国路88号</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91吃瓜 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="/about" className="hover:text-background-300 transition-colors">关于我们</a>
            <span>|</span>
            <a href="/about" className="hover:text-background-300 transition-colors">联系我们</a>
            <span>|</span>
            <a href="/about" className="hover:text-background-300 transition-colors">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}